import { NavigationSideBar, navigationSideBar } from "./side/NavigationSideBarComponent";
import { NavigationTopBar, navigationTopBar } from "./top/NavigationTopBarComponent";
import { userMenu, UserMenu } from "./user-menu/UserMenuComponent";

import Portfolios from "./portfolios";

export default function (parentDir: string): string {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.nav.components", [Portfolios(rootDir)])
        .component(NavigationSideBar, navigationSideBar(rootDir))
        .component(NavigationTopBar, navigationTopBar(rootDir))
        .component(UserMenu, userMenu(rootDir))
        .name;
}
